export default __webpack_public_path__ + "static/fonboarding-41b7299428cab38b1246fa8f6417b5e0.jpg";